import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FileUploadService } from 'src/app/services/file-upload-service/file-upload.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
    @Input() buttonIcon: 'Edit' | 'Add';
    @Input() allowMultipleUploads: boolean;
    @Input() acceptedFileTypes: string = "'.png, .jpg, .jpeg, .gif'";
    @Output() selected = new EventEmitter<string[]>();
    inputId = Math.random() + '';

    files: File[];
    private uploadCompleteSubscription: Subscription = null;

    constructor(private fileUploadService: FileUploadService) {}

    ngOnInit(): void {
        this.files = [];
    }

    public onUploadClicked(): void {
        this.files = [];
        const fileUpload = document.getElementById(
            this.inputId
        ) as HTMLInputElement;
        fileUpload.onchange = () => {
            for (let index = 0; index < fileUpload.files.length; index++) {
                const file = fileUpload.files[index];
                this.files.push(file);
            }
            this.uploadFiles();
        };
        fileUpload.click();
    }

    uploadFiles(): void {
        if (
            !this.uploadCompleteSubscription ||
            this.uploadCompleteSubscription.closed
        ) {
            this.uploadCompleteSubscription =
                this.fileUploadService.uploadComplete.subscribe(
                    (complete: string[]) => {
                        this.selected.emit(complete);
                        this.uploadCompleteSubscription.unsubscribe();
                    }
                );
        }

        const fileUpload = document.getElementById(
            this.inputId
        ) as HTMLInputElement;
        fileUpload.value = '';
        this.fileUploadService.uploadFiles(this.files);
    }
}
